import { SwiperContainer, register } from "swiper/element/bundle";
import { cardSliderOptions } from "./sliderOptions";
import { teaserCardSliderOptions } from "./teaserSliderOptions";
import { newsCardSliderOptions } from "./newsSliderOptions";

register();

function initializeSwipers(el: HTMLElement) {
  for (const swiperEl of el.querySelectorAll<SwiperContainer>(
    'swiper-container[init="false"].card-slider'
  )) {
    if (swiperEl.classList.contains("teaser-swiper")) {
      Object.assign(swiperEl, teaserCardSliderOptions);
    } else if (swiperEl.classList.contains("news-swiper")) {
      Object.assign(swiperEl, newsCardSliderOptions);
    } else {
      Object.assign(swiperEl, cardSliderOptions);
    }

    swiperEl.initialize();
  }
}

initializeSwipers(document.body);

// Use a mutation observer to find new sliders and initialize them
const observer = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (node instanceof HTMLElement) {
        initializeSwipers(node);
      }
    }
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
});
// add to the first three slides class is in view

const teaserSlider = document.querySelector(".teaser-swiper");

if (teaserSlider) {
  const swiperElement = teaserSlider.shadowRoot?.querySelector(".swiper");

  if (swiperElement) {
    swiperElement.setAttribute("style", "overflow: visible");
  }
}
